import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faMagicWandSparkles, faUsers } from '@fortawesome/free-solid-svg-icons';
import Navbar from './layout/Navbar';
import Footer from './layout/Footer';
import HeroSection from './landing/HeroSection';
import FeaturesSection from './landing/FeaturesSection';
import HowItWorksSection from './landing/HowItWorksSection';
import MethodologySection from './landing/MethodologySection';
import TestimonialsSection from './landing/TestimonialsSection';
import { COLORS } from '../constants/theme';

const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, ${COLORS.darkBg} 0%, ${COLORS.darkBgAlt} 100%);
  color: white;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
`;

const LandingPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const navLinks = [
    { href: '#features', icon: <FontAwesomeIcon icon={faCog} />, label: t('nav.features'), id: 'landing-nav-features-022' },
    { href: '#how-it-works', icon: <FontAwesomeIcon icon={faMagicWandSparkles} />, label: t('nav.howItWorks'), id: 'landing-nav-howitworks-023' },
    { href: '#testimonials', icon: <FontAwesomeIcon icon={faUsers} />, label: t('nav.testimonials'), id: 'landing-nav-testimonials-024' }
  ];

  return (
    <Container>
      <Navbar links={navLinks} />
      <HeroSection onGenerateClick={() => navigate('/app')} />
      <FeaturesSection />
      <HowItWorksSection />
      <MethodologySection />
      <TestimonialsSection />
      <Footer />
    </Container>
  );
};

export default LandingPage;
